import getFreshSideObject from "./getFreshSideObject.js";
export default function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}


//////////////////
// WEBPACK FOOTER
// /var/www/clients/client0/web6/deploy/releases/20230327134040/web/app/themes/metadieta/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
// module id = 31
// module chunks = 0